export default __webpack_public_path__ + "static/media/70_photo.b8753d89.jpg";